import React, { useState, useCallback } from 'react';
import { Form, Button, FormGroup, Col, Input, Label } from 'reactstrap';

import { authorizedPost } from '../api-authorization/AuthorizedFetch';

/* EXISTING STATE:
    

*/

const ClassEditor = ({
  schoolId, 
  value, 
  isNew, 
  onSaved
}) => {
  const [state, setState] = useState({
    ...value
  });

  const teacherEmailChanged = (e) => {
    const newTeacherEmail = e.target.value;
    setState((s) => {
      return {
        ...s,
        teacherEmail: newTeacherEmail
      }
    })
  }

  const nameChanged = (e) => {
    const newName = e.target.value;
    setState((s) => {
      return {
        ...s,
        name: newName
      };
    }); 
  }

  const save = useCallback(async () => {
    var response = await authorizedPost('api/classes', { schoolId, name: state.name, teacherEmail: state.teacherEmail });
    var body = await response.json();

    if(onSaved) {
      onSaved(body.classId);
    }
  }, [state, schoolId, onSaved]);

  return (
      <Form>
        <h3>{isNew ? "Create Class" : "Edit Class"}</h3>
        <FormGroup row>
          <Label for="teacherEmail" sm={2}>Teacher</Label>
          <Col sm={10}>
            <Input id="teacherEmail" name="teacherEmail" placeholder="Teacher Email" onChange={teacherEmailChanged} value={state.teacherEmail} type="email" />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label for="schoolName" sm={2}>Name</Label>
          <Col sm={10}>
            <Input id="schoolName" name="className" placeholder="Class Name" onChange={nameChanged} value={state.name} />
          </Col>
        </FormGroup>
        <FormGroup row style={{justifyContent:'center'}}><Button color="primary" style={{width: '20%'}} onClick={save}>{isNew ? "Create" : "Save"}</Button></FormGroup>
      </Form>
  );
}

export default ClassEditor;